const CDN_BASE = "https://cdn.kodland.org/quiz-kodland";

export const cdn = (path = "") => {
  const p = String(path);
  if (/^https?:\/\//.test(p)) return p;
  return `${CDN_BASE}/${p.replace(/^\/+/, "")}`;
};
